import get from 'lodash/get'
import formValueSelector from 'redux-form/lib/formValueSelector'
import hasSubmitSucceeded from 'redux-form/lib/hasSubmitSucceeded'
import isSubmitting from 'redux-form/lib/isSubmitting'
import {createSelector} from 'reselect'

import {and} from '../utils'

// Store selectors
export const vendorApplicationIsOpen = (state) => get(state, 'blackDesk.vendorApplicationIsOpen')
export const currentVendorForm = (state) => get(state, 'blackDesk.currentVendorForm')
export const vendorId = (state) => get(state, 'blackDesk.vendorId')

// Redux Form selectors
export const BLACK_DESK_VENDOR_FORM = 'BlackDeskVendorForm'
export const BLACK_DESK_ADDRESS_FORM = 'BlackDeskAddressForm'

export const vendorFormValues = formValueSelector(BLACK_DESK_VENDOR_FORM)
export const successfulVendorSignup = hasSubmitSucceeded(BLACK_DESK_VENDOR_FORM)
export const vendorFormIsSubmitting = isSubmitting(BLACK_DESK_VENDOR_FORM)

export const addressFormIsSubmitting = isSubmitting(BLACK_DESK_ADDRESS_FORM)
export const successfulAddressSubmit = hasSubmitSucceeded(BLACK_DESK_ADDRESS_FORM)

// Computed Selectors
export const completedVendorApplication = createSelector(
  successfulVendorSignup,
  successfulAddressSubmit,
  and,
)

const getCta = (signedUp, submittedAddress) => {
  if (signedUp && !submittedAddress) {
    return 'Get a free gift!'
  }
  if (signedUp && submittedAddress) {
    return 'You’re in!'
  }
  return 'Apply Now'
}

export const landingPageCtaText = createSelector(
  successfulVendorSignup,
  successfulAddressSubmit,
  getCta,
)
